import useGetter from "./useGetter";
import useLeagueSeason from "./useLeagueSeason";

export default function useDivisions() {
  const { leagueSeason } = useLeagueSeason();

  let leagueId = null;
  let season = null;
  if (leagueSeason) {
    leagueId = leagueSeason.obj.league;
    season = leagueSeason.obj.season;
  }

  const divisionsUrl = `/leagues/${leagueId}/${season}/divisions`;

  const enabled = !!leagueSeason;
  const { data: divisionsData, query: divisionsQuery } = useGetter(
    divisionsUrl,
    {
      enabled,
    }
  );

  return { divisionsData, divisionsQuery, divisionsUrl };
}
